import { jsx } from "react/jsx-runtime";
import { Checkbox } from "antd";
import classnames from "classnames";
import { forwardRef } from "react";
import { rootClass } from "./constant.js";
import Group from "./Group.js";
import "./index.css";
function InnerCheckbox(props, ref) {
    return /*#__PURE__*/ jsx(Checkbox, {
        ref: ref,
        ...props,
        className: classnames(rootClass, props.className)
    });
}
const checkbox_Checkbox = /*#__PURE__*/ forwardRef(InnerCheckbox);
checkbox_Checkbox.Group = Group;
const components_checkbox = checkbox_Checkbox;
export { components_checkbox as default };
